import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { SportStatisticsTypeEnum } from "@data-types/analytics-tracker/SportsStatisticsInteractionTypeEnum";
import { EventContentTab } from "@features/offer/shared/event";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { analyticsTracker } from "@utils/analytics";

export const LiveStatisticsButton = observer(
	function LiveStatisticsButton(props: {
		store: EventViewStore | AdditionalOfferViewStore;
	}) {
		const { t } = useTranslation();

		const { sportStatisticsStore } = props.store;

		return (
			<EventContentTab
				textContent={t("EVENT.HEADER.MATCH_STATS")}
				isActive={
					props.store.displayStatisticsGroup ===
					StatisticsGroups.LiveStats
				}
				disabled={sportStatisticsStore.isFetching}
				onClick={() => {
					if (
						props.store.displayStatisticsGroup !==
						StatisticsGroups.LiveStats
					) {
						analyticsTracker.trackSportStatisticsInteractionTracking(
							SportStatisticsTypeEnum.LiveStatisticsVisit
						);
						props.store.setDisplayStatisticsGroup(
							StatisticsGroups.LiveStats
						);
					}
				}}
			/>
		);
	}
);
